import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";

import { Tab } from "src/app/components/simple-tabs/simple-tabs.component";
import { LocalStateService } from "src/app/services/local-state/local-state.service";

export interface RouteLink {
	label: string;
	link?: string;
	subLabels?: ReadonlyArray<{ label: string; link: string }>;
}

@Component({
	selector: "app-default-layout",
	templateUrl: "./default-layout.component.html",
	styleUrls: ["./default-layout.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class DefaultLayoutComponent implements OnInit {
	tabs: Tab[] = [
		{
			id: "inspection-list",
			label: "Inspection History",
			defaultActive: true,
			data: null,
		},
		{
			id: "defects",
			label: "Defects",
			defaultActive: true,
			data: null,
		},
		{
			id: "missing-inspections",
			label: "Missing Inspections",
			defaultActive: true,
			data: null,
		},
		{
			id: "settings",
			label: "Settings",
			defaultActive: true,
			data: null,
		},
	];
	routeByTabId: Record<string, string> = {
		"inspection-list": "/inspection-list",
		defects: "/defects",
		"missing-inspections": "/missing-inspections",
		settings: "/settings",
	};
	showTabs = false;

	constructor(private router: Router, private localStateService: LocalStateService) {}

	ngOnInit(): void {
		this.showTabs = this.localStateService.getPXLogin();
	}

	onTabClicked(tab: Tab) {
		this.router.navigate([this.routeByTabId[tab.id]], {
			queryParams: { pxLogin: this.localStateService.getPXLogin() },
		});
	}
}
